var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "delivery_mode ", class: { botto_border: !_vm.isLastItem } },
    [
      _c("div", { staticClass: "font_regular text_16 font_600 word_break" }, [
        _vm._v(_vm._s(_vm.item.title))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "price_time" }, [
        _c(
          "div",
          {
            staticClass:
              "font_regular text_12 font_600 text_black_secondary word_break"
          },
          [_vm._v(_vm._s(_vm.item.time))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "font_regular text_14 font_500" }, [
          _vm._v(
            "\n          " +
              _vm._s(_vm.merchant.paid_by_customer ? _vm.item.amount : 0) +
              "\n          " +
              _vm._s(_vm.item.currency) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "radio_btn_container" }, [
        _c("label", { staticClass: "radio_wrap", attrs: { for: "" } }, [
          _c("input", {
            attrs: { type: "radio" },
            domProps: {
              value: _vm.item.id,
              checked: _vm.selectedMode === _vm.item.id
            },
            on: {
              change: function($event) {
                return _vm.handleChange(_vm.item)
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }